var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tw-py-4 bg-credits"},[_c('text-secondary',{staticClass:"tw-text-sm"},[_vm._v("© 2021 — MicroCenter")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }